import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { FLUTTER_APPS } from "app/flutter.apps.generated";
import { LoaderType } from "libraries/component/loader/loader.component";
import { ILoader } from "libraries/component/loader/ILoader";
import { INotification } from "libraries/interfaces/INotification";
import { Yii } from "libraries/interfaces/Yii";
import { EAction } from "libraries/interfaces/ancillary-services/e-actions";

@Component({
    selector: 'ancillary-services-summary',
    template: `
        <iframe-app-embedder-ancillary-summary [iframeSrc]="appUrl"
                                               [iframeName]="'ancillaryServicesSummary'"
                                               [isDynamicHeight]="true"
                                               [additionalData]="additionalData"
                                               (onIframeEvent)="doAction($event)">
        </iframe-app-embedder-ancillary-summary>

    `,
    styles: [`

        iframe-app-embedder-ancillary-summary{
            margin-bottom: 0.75rem;
            padding: 0 1px;
        }
        loader {
            background: white;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AncillaryServicesSummaryComponent implements OnInit, OnChanges {

    @Input()
    public selection: any;

    @Input()
    public canCreateBooking: boolean;


    public appUrl: string;

    public additionalData: { servicesResponse: any, servicesRequestBase?: any };

    public loader: ILoader = {
        active: true,
        type: LoaderType.large,
        message: Yii.t('wui-shared-js', 'Chargement en cours'),
    };

    public notification: INotification = {
        active: false,
        message: Yii.t('wui-shared-js', 'Une erreur est survenue.'),
    };

    @Output()
    private readonly onCreate: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        this.appUrl = FLUTTER_APPS.ancillary_services_summary_app;
        if (this.selection) {
            this.additionalData = {
                servicesResponse: {
                    "error": false,
                    "warning": false,
                    "code": 200,
                    "message": null,
                    data: this.selection,
                }
            };
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.selection?.currentValue && !changes?.selection?.firstChange) {
            this.additionalData = {
                servicesResponse: {
                    "error": false,
                    "warning": false,
                    "code": 200,
                    "message": null,
                    data: this.selection,
                }
            };
            this.changeDetectorRef.detectChanges();
        }
    }

    public doAction(action: any): void {
        switch (action.name) {
            case EAction.bookingCreation:
                if (this.canCreateBooking) {
                    this.onCreate.emit();
                }
                break;
            default:
                break;
        }
    }
}
